import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import SettingsList from "superAdminViews/setting/SettingsList";

const ADD = gql`
  mutation createAttributeByAdmin($name: String!, $attributeGroup: ID!) {
    createAttributeByAdmin(inputs: { name: $name, attributeGroup: $attributeGroup }) {
      _id
      name
    }
  }
`;

const GET = gql`
  query getAttributes($limit: Int, $skip: Int) {
    getAttributes(pagination: { limit: $limit, skip: $skip }) {
      _id
      name
      attributeGroup {
        _id
        name
        rootCategory {
          _id
          title
        }
      }
    }
  }
`;

const COUNT = gql`
  query getAttributesCount {
    getAttributesCount
  }
`;

const UPDATE = gql`
  mutation updateAttributeByAdmin($id: ID!, $attributeGroup: ID!, $name: String!) {
    updateAttributeByAdmin(id: $id, inputs: { attributeGroup: $attributeGroup, name: $name }) {
      _id
      name
    }
  }
`;

const DELETE = gql`
  mutation deleteAttributeByAdmin($idSet: [ID!]!) {
    deleteAttributeByAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const GET_GROUPS = gql`
  query getAttributeGroups {
    getAttributeGroups {
      _id
      name
    }
  }
`;

/**
 * Attributes - the individual options inside each attribute group.
 */
const Attributes = () => {
  const { data } = useQuery(GET_GROUPS);
  const groups = (data && data.getAttributeGroups) || [];
  const groupOptions = groups.map((group) => ({ value: group._id, label: group.name }));

  return (
    <SettingsList
      title="Attributes"
      description="The individual choices inside each group — sizes, toppings, finishes."
      singular="attribute"
      list={{ query: GET, key: "getAttributes" }}
      count={{ query: COUNT, key: "getAttributesCount" }}
      create={{
        mutation: ADD,
        variables: (values) => ({
          name: values.name.trim(),
          attributeGroup: values.attributeGroup,
        }),
      }}
      update={{
        mutation: UPDATE,
        variables: (values, row) => ({
          id: row._id,
          name: values.name.trim(),
          attributeGroup: values.attributeGroup,
        }),
      }}
      remove={{ mutation: DELETE }}
      columns={[
        { key: "name", label: "Attribute", width: "2fr" },
        {
          key: "attributeGroup",
          label: "Group",
          width: "2fr",
          render: (row) => (row.attributeGroup ? row.attributeGroup.name : "—"),
        },
        {
          key: "rootCategory",
          label: "Shop type",
          render: (row) =>
            row.attributeGroup && row.attributeGroup.rootCategory
              ? row.attributeGroup.rootCategory.title
              : "—",
        },
      ]}
      fields={[
        { name: "name", label: "Attribute", type: "text", required: true },
        {
          name: "attributeGroup",
          label: "Group",
          type: "select",
          required: true,
          options: groupOptions,
        },
      ]}
      toValues={(row) => ({
        name: row.name,
        attributeGroup: row.attributeGroup ? row.attributeGroup._id : "",
      })}
    />
  );
};

export default Attributes;
